






























































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import ErrorMessages from '@/components/ErrorMessages.vue'
import { FacilityModule } from '@/store/modules/facility.module'

import Api from '@/api'
import Card from '@/components/Card.vue'

@Component({
  components: {
    Card,
    Checkbox,
    ErrorMessages
  }
})
export default class AcceptAgreement extends Vue {
  isImporting: boolean = false
  hipaaAgreementAccepted: boolean = false
  licenseAgreementAccepted: boolean = false
  errors: string[] = []

  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)

  get selectedFacilitiesRaw () {
    return decodeURIComponent(this.$route.query.facilities as string)
  }

  get selectedFacilitiesDTO () {
    return JSON.parse(this.$route.query.facilities as string)
  }

  downloadHippaAgreement () {
    Api.facility.downloadHippaAgreement(this.userName, this.selectedFacilitiesRaw)
  }

  downloadLicenseAgreement () {
    Api.facility.downloadLicenseAgreement(this.userName, this.selectedFacilitiesRaw)
  }

  get userName () {
    const user = Api.getUser()
    return user && user.getFullName()
  }

  validate () {
    this.errors = []
    if (!this.hipaaAgreementAccepted) {
      this.errors.push('Accept HIPAA Agreement')
    }
    if (!this.licenseAgreementAccepted) {
      this.errors.push('Accept Zunta License Agreement')
    }
    return this.errors.length === 0
  }

  async importFacilities () {
    if (!this.validate()) {
      return
    }
    this.$eventBus.$emit('loading:enable', { message: 'Importing Facilities' })
    this.isImporting = true
    await this.facilityModuleInstance.importSelectedFacilities()
    this.isImporting = false
    this.$eventBus.$emit('loading:disable')
    this.$eventBus.$emit('notify', {
      color: 'var(--status-success-color)',
      message: 'Facilities are fetching and will be available within 2-10 minutes.',
      header: `Import Facilities`,
      icon: 'check'
    })
    this.$router.push({ name: 'management-facilities' })
  }
}
